<div class="min-h-screen bg-gray-50 flex">
  <!-- Left Side: Image (Hidden on mobile) -->
  <div class="hidden lg:block lg:w-3/5 relative">
    <div class="absolute inset-0 bg-white rounded-br-[50px] rounded-tr-[50px] overflow-hidden z-10 shadow-xl">
      <img src="assets/images/Frame_1000004687.png" alt="Login Background" class="w-full h-full object-cover" />
    </div>
  </div>

  <!-- Right Side: Form with Footer -->
  <div class="w-full lg:w-2/5 flex flex-col">
    <!-- Form Content -->
    <div class="flex-1 flex items-center justify-center p-8 bg-white">
      <div class="w-full max-w-md space-y-8">
        <!-- Logo & Header -->
        <div class="text-center">
          <img src="assets/images/logometasmile.png" alt="Metasmile Logo" class="h-16 mx-auto mb-6 object-contain" />
          <!-- <h2 class="text-3xl font-bold text-gray-900">
            {{ 'q47ahd51' | translate }}
          </h2> -->
        </div>

        <!-- Error Message -->
        <div *ngIf="error$ | async as error" class="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm text-red-700">{{ error | translate }}</p>
            </div>
          </div>
        </div>

        <!-- Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-8 space-y-6">
          <div class="space-y-5">
            <!-- Email Input -->
            <div class="flex flex-col gap-1.5">
              <label class="text-[10px] font-black text-slate-500 uppercase tracking-[0.15em]">
                {{ 'py61lw1x' | translate }} <span class="text-rose-500">*</span>
              </label>
              <input pInputText formControlName="email" type="email" [placeholder]="'abc16f4x' | translate"
                class="w-full !rounded-xl !border-slate-200 focus:!border-primary focus:!ring-1 focus:!ring-primary transition-all p-2.5 !text-[13px]"
                [class.ng-invalid]="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
                [class.ng-dirty]="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" />
              <small *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
                class="text-rose-500 text-[9px] uppercase tracking-wider font-bold">
                {{ 'email_required' | translate }}
              </small>
            </div>

            <!-- Password Input -->
            <div class="flex flex-col gap-1.5">
              <label class="text-[10px] font-black text-slate-500 uppercase tracking-[0.15em]">
                {{ '58llhd2u' | translate }} <span class="text-rose-500">*</span>
              </label>
              <p-password formControlName="password" [placeholder]="'lkdxaydo' | translate" [toggleMask]="true"
                [feedback]="false" styleClass="w-full"
                inputStyleClass="w-full !rounded-xl !border-slate-200 focus:!border-primary focus:!ring-1 focus:!ring-primary transition-all p-2.5 !text-[13px]"
                [class.ng-invalid]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid"
                [class.ng-dirty]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid"></p-password>
              <small *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid"
                class="text-rose-500 text-[9px] uppercase tracking-wider font-bold">
                {{ 'password_required' | translate }}
              </small>
            </div>
          </div>

          <div class="pt-2">
            <app-button [fullWidth]="true" type="submit" [loading]="(isLoading$ | async) || false"
              [disabled]="loginForm.invalid" [label]="'11ys852x' | translate" variant="primary"></app-button>
          </div>

          <div class="flex items-center justify-between mt-4">
            <div class="flex items-center gap-2">
              <p-checkbox id="remember-me" formControlName="rememberMe" [binary]="true"
                class="cursor-pointer scale-75 origin-left"></p-checkbox>
              <label for="remember-me"
                class="text-[8.5px] text-slate-500 cursor-pointer select-none uppercase tracking-[0.1em] font-black">
                {{ 'hmm2o7th' | translate }}
              </label>
            </div>

            <div class="text-[8.5px]">
              <a (click)="onForgotPassword()" [class.opacity-50]="forgotPasswordLoading"
                [class.pointer-events-none]="forgotPasswordLoading"
                class="font-black text-primary hover:text-primary-hover cursor-pointer inline-flex items-center gap-2 transition-colors uppercase tracking-[0.1em]">
                <i *ngIf="forgotPasswordLoading" class="pi pi-spin pi-spinner text-[8px]"></i>
                {{ 'mbhmre1v' | translate }}
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Footer (only on form side) -->
    <div class="h-16">
      <app-auth-footer />
    </div>
  </div>
</div>